import { Services } from "../../ServiceLocator";
import { postData } from "../Api/Actions";
import { calculatePrice, receiveConfiguration, setConfigurationChanged } from "../Configuration/Actions";
import { setWorkInProgress } from "../Ui/Actions";
import { sum } from "lodash";

export const ADD_FIELD = "BERT_WAREHOUSE_ADD_FIELD";
export const REMOVE_FIELD = "BERT_WAREHOUSE_REMOVE_FIELD";
export const UPDATE_FIELD = "BERT_WAREHOUSE_UPDATE_FIELD";
export const UPDATE_LAYER = "BERT_WAREHOUSE_UPDATE_LAYER";
export const UPDATE_GLOBAL_PARAMETER = "BERT_WAREHOUSE_UPDATE_GLOBAL_PARAMETER";
export const RECEIVE_BERT_WAREHOUSE_CONFIGURATION = "BERT_WAREHOUSE_RECEIVE_BERT_ARCHIVE_CONFIGURATION";

export const addNewField = () => (dispatch) => {
  dispatch({
    type: ADD_FIELD,
  });
  dispatch(setConfigurationChanged(true));
  dispatch(calculatePrice());
};

export const removeField = (fieldId) => async (dispatch) => {
  await dispatch({
    type: REMOVE_FIELD,
    fieldId,
  });
  dispatch(setConfigurationChanged(true));
  dispatch(calculatePrice());
  return dispatch(updateOverallWidth());
};

export const updateField = (fieldId, key, value) => (dispatch) => {
  dispatch({
    type: UPDATE_FIELD,
    fieldId,
    key,
    value,
  });
  dispatch(setConfigurationChanged(true));
  dispatch(calculatePrice());
};

export const updateLayer = (fieldId, layerId, key, value) => (dispatch) => {
  dispatch({
    type: UPDATE_LAYER,
    fieldId,
    layerId,
    key,
    value,
  });
  dispatch(setConfigurationChanged(true));
  dispatch(calculatePrice());
};

export const updateGlobalParameterBertWarehouse = (key, value) => (dispatch) => {
  dispatch({
    type: UPDATE_GLOBAL_PARAMETER,
    key,
    value,
  });
  if (key !== "scaleFactor" && key !== "overallWidth") {
    dispatch(setConfigurationChanged(true));
    dispatch(calculatePrice());
  }
};

export const setBertWarehouse = (data) => (dispatch) => {
  dispatch({
    type: RECEIVE_BERT_WAREHOUSE_CONFIGURATION,
    data,
  });
};

export const saveBertWarehouseConfiguration = (configurationtype = "", screenshot) => (
  dispatch,
  getState
) => {
  const { configuration } = getState().Configuration;
  const bertWarehouse = getState().BertWarehouse;
  const configurationWithBertWarehouse = {
    ...configuration,
    code: configurationtype === 'cart' ? configuration.code : null,
    customdata: { ...configuration.customdata, bertWarehouse },
    screenshots: screenshot,
  };
  return dispatch(
    postData(
      "frontendapi/configurations",
      {
        configuration: configurationWithBertWarehouse,
        configurationtype,
      },
      receiveConfiguration
    )
  ).then((result) => {
    if (configurationtype === "print") {
      Services.store.dispatch(setWorkInProgress("pdfDownload", false));
    } else {
      Services.store.dispatch(setWorkInProgress("saveConfiguration", false));
    }
    return result;
  });
};

export const updateOverallWidth = () => (dispatch, getState) => {
  const { fields } = getState().BertWarehouse;
  const overallWidth =
    sum(
      fields.map((field) => {
        return Number(field.width.match(/\d+/));
      })
    ) + 56;
  dispatch(updateGlobalParameterBertWarehouse("overallWidth", overallWidth));
};
